import React, { forwardRef } from 'react'
import { Input, InputProps } from '../ui/input'
import InputGroup, { InputGroupProps } from './input-group'

type TextInputProps = InputProps & InputGroupProps

/**
 * Text Input field
 */
const TextInput = forwardRef<HTMLInputElement, TextInputProps>(({
    label,
    error,
    wrapperClassName,
    labelClassName,
    errorClassName,
    labelFor,
    ...props
}, ref) => {
    return (
        <InputGroup 
            label={label}
            error={error}
            labelFor={labelFor}
            wrapperClassName={wrapperClassName}
            labelClassName={labelClassName}
            errorClassName={errorClassName}
        >
            <Input ref={ref} {...props} />
        </InputGroup>
    )
})

TextInput.displayName = 'TextInput'

export default TextInput